import React, { Fragment, useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Popover, PopoverBody, PopoverHeader } from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import { mapReturnRequestResponseToTable, mapSearchAutoSuggestion } from "../../../utils/mapper";
import { useDispatch, useSelector } from "react-redux";
import debounce from 'lodash/debounce';
import withReducer from "../../../store/withReducer";
import {
    getAllPendingReturnRequest,
    getOrderSettings,
    setSettings,
    exportPendingReturnDetails, selectOrder, setPendingReturnFilter
} from "../store/orderSlice";
import { useHistory, useParams, Link } from "react-router-dom";
import orderReducer from "../store";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import PreLoader from "../../../share-components/ui/preLoader";
import DatePicker from "../../../share-components/ui/DateRangePicker";


import Select from "react-select";
import AsyncSelect from "react-select/async";
import { sellerAutoSuggestionApi } from "../../../services/manage-product/productService";
import { getBrands } from "../../manage-product/store/inventorySlice";
import { DateRangePicker } from 'rsuite';
import { pendingReturnFilters } from "../../manage-product/product/edit/content/settings/map";
import StatusSummary from "./components/StatusSummary";
import { SkuAutoSuggestion } from "../../../services/order";
import "./styles.scss";


const { afterToday } = DateRangePicker;

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 50,
        border: 'none',
    })
};

const PendingReturn = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    let history = useHistory();
    const [page, setPage] = useState(1);
    const TodayDate = new Date();
    const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
    const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
    const [startDate, endDate] = dateRange;
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [seller, setSeller] = useState(null);
    const orderState = useSelector(({ order }) => order.order);
    const backInRequestState = useSelector(({ backStore }) => backStore.backStoreRequest);
    const userState = useSelector(({ authReducer }) => authReducer.data);
    const [searchSeller, setSearchSeller] = useState('');
    const [brands, setBrands] = useState(null);
    const [brandsVal, setBrandsVal] = useState(null);
    const [reason, setReturnReason] = useState(null);
    const [timer, setTimer] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [type, setReturnType] = useState(null);
    const orderPendingReturn = useSelector(selectOrder);
    const submitTypes = ["submit", "update", "save"];
    const [differentPage, setDifferentPage] = useState(!submitTypes.includes(history.location.state?.from));
    const [pageLoading, setPageLoading] = useState(history.location.state?.from !== "update" || orderPendingReturn.length < 1);
    const [isFilterable, setIsFilterable] = useState((history.location.state?.from !== "update" || orderPendingReturn.length < 1));
    const currentUser = useSelector(({authReducer}) => authReducer.data.user);

    // Looklab Products
    const [skuOptions, setSkuOptions] = useState([]);
    const [selectedSkus, setSelectedSkus] = useState([]);
    const [pageSku, setSku] = useState(1);
    const [hasMoreSku, setHasMoreSku] = useState(true);
    const [loadingSku, setLoadingSku] = useState(false);
    const [skuError, setSkuError] = useState(false);
    const [querySku, setQuerySku] = useState('');
    const [loadingAvailableInType, setLoadingAvailableInType] = useState(false);

    const statuses = [
        // { 'id': 0, 'name': 'All' },
        { 'id': 1, 'name': 'Pending (All)' },
        { 'id': 10, 'name': 'Pending (Return Free)' },
        { 'id': 11, 'name': 'Pending (Return Fee Paid)' },
        { 'id': 12, 'name': 'Pending (Return Fee Not Paid)' },
        { 'id': 2, 'name': 'All Approved' },
        { 'id': 3, 'name': 'All Declined' },
        { 'id': 4, 'name': 'Partially Approved, Partially Declined' },
    ];

    const trackingStatuses = [
        // { 'id': 0, 'name': 'All' },
        { 'id': 1, 'name': 'Pending' },
        { 'id': 2, 'name': 'In Transit' },
        { 'id': 3, 'name': 'Delivered' },
    ];
    
    const dataMenu = [
        {
            type: 1,
            text: 'Orders',
            link: '/order'
        },
        {
            type: 0,
            text: "Pending Return Requests"
        }
    ];

    const paymentTypeOptions = [
        { id: 'shopify_payments', name: 'Shopify Payments' },
        { id: 'paypal', name: 'Paypal' },
        { id: 'Bank Deposit', name: 'Bank Deposit' },
        { id: 'others', name: 'Others' },
    ];


    const authData = useSelector(({ authReducer }) => authReducer);
    useEffect(() => {
        if (differentPage) {
            dispatch(setPendingReturnFilter(pendingReturnFilters(authData.defaultSeller)));
        }
    }, []);
    useEffect(() => {
        if (!differentPage && (isFilterable || ((isFilterable) && authData.defaultSeller?.value != orderState.pendingFilters.seller?.value))) {
            dispatch(setPendingReturnFilter({
                ...orderState.pendingFilters,
                seller: authData.defaultSeller,
                currentPage: 1
            }));
        }
    }, [authData.defaultSeller]);

    useEffect(() => {
        dispatch(getOrderSettings()).then(res => {
            dispatch(setSettings(res.payload))
        });
    }, [dispatch]);

    useEffect(() => {
        if (dateRange[0] !== null && dateRange[1] !== null)
            getData();
    }, [dateRange]);

    useEffect(() => {
        const data = {
            value: '',
            seller_id: orderState.pendingFilters.seller ? orderState.pendingFilters.seller.value : '',
        }
        dispatch(getBrands(data)).then(res => {
            setBrands(res.payload);
        });
    }, [dispatch, orderState.pendingFilters.seller])


    const getData = () => {
        if (isFilterable) {
            const pendingFilters = orderState.pendingFilters;
            if (differentPage && JSON.stringify(pendingFilters) != JSON.stringify(pendingReturnFilters(authData.defaultSeller))) {
                setDifferentPage(false);
            } else {
                setLoading(true);
                dispatch(getAllPendingReturnRequest({
                    page: pendingFilters.currentPage,
                    pageSize: pendingFilters.pageSize,
                    dateRangeX: dateRange[0] !== null ? moment(dateRange[0]).format('YYYY-MM-DD') : null,
                    dateRangeY: dateRange[1] !== null ? moment(dateRange[1]).format('YYYY-MM-DD') : null,
                    // start_date: moment(startDate).format('YYYY-MM-DD'),
                    // end_date: moment(endDate).format('YYYY-MM-DD'),
                    seller: orderState.pendingFilters.seller ? orderState.pendingFilters.seller.value : '',
                    search: orderState.pendingFilters.search,
                    mp_order_no: orderState.pendingFilters.mp_order_no,
                    brand: orderState.pendingFilters.brand ? orderState.pendingFilters.brand.id : '',
                    // reason: orderState.pendingFilters.reason? orderState.pendingFilters.reason.value:'',
                    type: orderState.pendingFilters.type ? orderState.pendingFilters.type.value : '',
                    partner: orderState.pendingFilters.partner ? orderState.pendingFilters.partner.id : '',
                    paymentMethod: orderState.pendingFilters.paymentMethod ? orderState.pendingFilters.paymentMethod.id : '',
                    status_id: orderState.pendingFilters.status ? orderState.pendingFilters.status.id : null,
                    tracking_status_id: orderState.pendingFilters.trackingStatus ? orderState.pendingFilters.trackingStatus.id : null,
                    customStatus: orderState.pendingFilters.customStatus ? orderState.pendingFilters.customStatus : null,
                    sku : orderState.pendingFilters.sku || "",
                })).then(res => {
                    setPageLoading(false);
                    setLoading(false);
                })
                setDifferentPage(false);
            }
        }
        setIsFilterable(true);
    }

    useEffect(() => {
        getData();
    }, [
        orderState.pendingFilters.currentPage, orderState.pendingFilters.pageSize, orderState.pendingFilters.seller, orderState.pendingFilters.partner,
        orderState.pendingFilters.search, orderState.pendingFilters.brand, orderState.pendingFilters.type, orderState.pendingFilters.paymentMethod,
        orderState.pendingFilters.mp_order_no, orderState.pendingFilters.status, orderState.pendingFilters.trackingStatus, orderState.pendingFilters.customStatus,orderState.pendingFilters.sku,
    ]);

     const fetchSKUOptions = async (inputValue, page) => {
        if (loadingSku || !hasMoreSku) return;
        setLoadingSku(true);
        
        try {
            let searchData = {
                q: inputValue,
                page: page,
                page_size: 15, // Number of items per page
            };
            const response = await SkuAutoSuggestion(searchData);
            const newOptions = response.response.data;

            setSkuOptions(prevOptions => (page === 1 ? newOptions : [...prevOptions, ...newOptions]));
            setHasMoreSku(newOptions.length === 15); // Check if there are more options
            setSku(page + 1);
            setLoadingSku(false);
        } catch (error) {
            setLoadingSku(false);
            console.error('Error fetching options:', error);
        }
    };

    // Debounced function for fetching options
    const debouncedFetchSKUOptions = useCallback(debounce((inputValue, page) => fetchSKUOptions(inputValue, page), 500), []);

    // Handle input change to fetch options
    const handleInputChangeSku = (inputValue) => {
        setSku(1);
        setHasMoreSku(true);
        setQuerySku(inputValue);
        debouncedFetchSKUOptions(inputValue, 1);
    };

    // Handle load more options when scrolling
    const handleMenuScrollToBottomSKU = () => {
        if (hasMoreSku) {
            fetchSKUOptions(querySku, pageSku);
        }
    };
    
    const handleMenuOpenSKU = () => {
        fetchSKUOptions(querySku, 1);
    };

    const sellerPromiseOption = (inputValue) =>
        new Promise((resolve) => {
            const data = {
                value: inputValue
            }
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)))
            });
        });

    const actionColumnCell = (row) => {
        return (<>
            {row.status_id == 1 && (
                <Link
                    className="btn btn-primary btn-sm px-2 py-1"
                    style={{ cursor: "pointer" }}
                    to={`${process.env.PUBLIC_URL}/order/pending-return-requests/${row.id}/edit`}
                ><i className="fa fa-reply"></i></Link>
            )}

            {(currentUser.permission).includes('View Pending Return') &&
            <Link
                className="btn btn-info btn-sm px-2 py-1 ml-2"
                style={{ cursor: "pointer" }}
                to={`${process.env.PUBLIC_URL}/order/pending-return-requests/${row.id}/view`}
            ><i className="fa fa-eye"></i></Link>}
        </>);
    }

    const returnHistories = [
        { id: 1, status_at: '2023-01-01', status: 'Approved' },
    ];

    const returnHistory = (histories) => {
        if (!histories || histories.length === 0) {
            return null; // or any message or placeholder you want to display when the data is empty
        }

        return (
            <table width={450} className="restock-history">
                <thead>
                    <tr>
                        <th>Brand</th>
                        <th>Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {histories.map((item, index) => (
                        <tr key={index}>
                            <td>{item.brand_name}</td>
                            <td>{item.eavent_status_at ? item.eavent_status_at : '-'}</td>
                            <td>{item.eavent_status}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const PopoverBasicItem = (props) => {
        const { id, btntext, locationName, histories, Popoverheader } = props;
        const [popover, setPopover] = useState(false)
        const Toggle = () => setPopover(!popover);
        return (
            <>
                <p style={{ cursor: "pointer" }} className="example-popover" id={"Popover-" + id}>
                    {btntext} 
                    {locationName && <small className="pl-1 font-weight-bold">({locationName})</small>}
                    <i className="fa fa-info-circle"></i>
                </p>
                <Popover
                    placement="top"
                    isOpen={popover}
                    target={"Popover-" + id}
                    toggle={Toggle}
                    trigger="hover"
                >
                    {(Popoverheader)
                        ? <PopoverHeader className="restock-history-header" tag={"div"}>{Popoverheader}</PopoverHeader>
                        : <></>
                    }
                    <PopoverBody>
                        {returnHistory(histories)}
                    </PopoverBody>
                </Popover>
            </>
        );
    };

    const tableColumns = [
        {
            name: 'Order ID',
            selector: row => row.orderName,
            cell: (row) => <Link className="text-primary" style={{ cursor: "pointer" }} target="_blank" to={`${process.env.PUBLIC_URL}/order/${row.order_id}/view`}>{row.orderName}</Link>,
            sortable: true,
            center: false,
        },
        {
            name: 'Order Date',
            selector: row => row.orderDate,
            sortable: true,
            center: false,
        },
        {
            name: 'Customer Name',
            selector: row => row.customerName,
            sortable: true,
            center: false,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
            center: false,
        },
        {
            name: 'Reason',
            selector: row => row.reason,
            sortable: true,
            center: false,
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            center: true,
        },
        {
            name: 'Return Status',
            selector: row => row.status,
            sortable: true,
            center: true,
        },
        {
            name: 'Tracking Status',
            selector: row => row.status,
            cell: (row) => {
                return (
                    (row.tracking_status_lists && row.tracking_status_lists.length >= 2) ?
                    <PopoverBasicItem id={row.id} btntext={row.tracking_status.eavent_status} locationName={row.tracking_status.location_name} histories={row.tracking_status_lists} Popoverheader={"Return History"} />
                    : (row.tracking_status ? <span>
                        <span>{row.tracking_status.eavent_status}</span>
                        {row.tracking_status.location_name && <small className="pl-1 font-weight-bold">({row.tracking_status.location_name})</small>}
                    </span> 
                    : 'Return Fee Not Paid')
                );
            },
            sortable: true,
            center: true,
        },
        {
            name: 'Action',
            selector: row => row.id,
            cell: actionColumnCell,
            sortable: false,
            right: true,
        }
    ];

    const pageChange = (e) => {
        dispatch(setPendingReturnFilter({ ...orderState.pendingFilters, currentPage: e }))
    }

    const onPageSizeChange = (e) => {
        dispatch(setPendingReturnFilter({ ...orderState.pendingFilters, currentPage: 1, pageSize: e }))
    }

    const [importDdpFile, setImportDdpFile] = useState(false);

    const exportPendingReturn = () => {
        setLoading(true)
        setImportDdpFile(false)
        const pendingFilters = orderState.pendingFilters;
        const data = {
            start_date: moment(startDate).format('YYYY-MM-DD'),
            end_date: moment(endDate).format('YYYY-MM-DD'),
            // seller: searchSeller?.value,
            brandsVal: brandsVal ? brandsVal : '',

            page: pendingFilters.currentPage,
            pageSize: pendingFilters.pageSize,
            dateRangeX: dateRange[0] !== null ? moment(dateRange[0]).format('YYYY-MM-DD') : null,
            dateRangeY: dateRange[1] !== null ? moment(dateRange[1]).format('YYYY-MM-DD') : null,
            // start_date: moment(startDate).format('YYYY-MM-DD'),
            // end_date: moment(endDate).format('YYYY-MM-DD'),
            seller: orderState.pendingFilters.seller ? orderState.pendingFilters.seller.value : '',
            search: orderState.pendingFilters.search,
            mp_order_no: orderState.pendingFilters.mp_order_no,
            brand: orderState.pendingFilters.brand ? orderState.pendingFilters.brand.id : '',
            // reason: orderState.pendingFilters.reason? orderState.pendingFilters.reason.value:'',
            type: orderState.pendingFilters.type ? orderState.pendingFilters.type.value : '',
            partner: orderState.pendingFilters.partner ? orderState.pendingFilters.partner.id : '',
            paymentMethod: orderState.pendingFilters.paymentMethod ? orderState.pendingFilters.paymentMethod.id : '',
            status_id: orderState.pendingFilters.status ? orderState.pendingFilters.status.id : 1,
            tracking_status_id: orderState.pendingFilters.trackingStatus ? orderState.pendingFilters.trackingStatus.id : null,
            customStatus: orderState.pendingFilters.customStatus ? orderState.pendingFilters.customStatus : null,
            sku : orderState.pendingFilters.sku || "",
        }
        const outputFilename = `Pending_Return_Report_${(new Date().toJSON().slice(0, 10))}.csv`;
        dispatch(exportPendingReturnDetails({ ...data })).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.payload]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', outputFilename);
            document.body.appendChild(link);
            link.click();
            setLoading(false)
        });
    }

    const returnTypeOptions = [
        { value: 1, label: 'Return By Customer' },
        { value: 2, label: 'Exchange By Customer' },
        { value: 3, label: 'Return By Admin' },

    ]

    function handleSkuValue(e){
        setSkuError(false)

        if(e.length > 10){
            setSkuError(true)
            return;
        }

        setSelectedSkus(e)

        const skuString = e.map(item => item.sku.trim()).join(",");
   
        dispatch(setPendingReturnFilter({
            ...orderState.pendingFilters,
            sku: skuString,
            currentPage: 1,
        }));
    }

    return (
        <Fragment>
            {pageLoading ? <>
                <PreLoader></PreLoader>
            </> : <>
                <Breadcrumb title="Pending Return Requests" data={dataMenu} />
                <Container fluid={true} className="pending-return-request-page">
                    <div className="product-grid mb-3">
                        <div className="feature-products">
                            <Row>
                                <Col sm="" className="mb-3">
                                    <div className='float-sm-right'>
                                        <Button color="primary" className="btn btn-primary btn-square"
                                            onClick={() => { exportPendingReturn() }}
                                        >Export</Button>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="">
                                    <Form>
                                        <FormGroup>
                                            <DatePicker
                                                dateRange={dateRange}
                                                dateRangeChange={(update) => {
                                                    setDateRange(update)
                                                }}
                                                disabledDate={afterToday()}
                                                defaultValue={[TodayDate, sevenDays]}
                                                paddingLeft={0}
                                            />
                                        </FormGroup>
                                    </Form>
                                </Col>

                                {/*{((userState.user.role.name !== "Seller") || (userState.user.is_primary_seller)) &&
                                    <Col sm="">
                                        <Select
                                            placeholder="Filter by Partner"
                                            className="select2-filter"
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            isClearable
                                            cacheOptions
                                            styles={customStyles}
                                            defaultValue={orderState.pendingFilters.partner}
                                            options={orderState.settings.partner}
                                            onChange={(e) => {
                                                dispatch(setPendingReturnFilter({
                                                    ...orderState.pendingFilters,
                                                    partner: e ? e : null,
                                                    currentPage: 1,
                                                }));
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                        />
                                    </Col>
                                }*/}

                                {((userState.user.role.name !== "Seller") || (userState.user.is_primary_seller)) &&
                                    <Col sm="">
                                        <Select
                                            className="select2-filter"
                                            styles={customStyles}
                                            value={orderState.pendingFilters.paymentMethod}
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            onChange={(e) => {
                                                dispatch(setPendingReturnFilter({
                                                    ...orderState.pendingFilters,
                                                    paymentMethod: e ? e : null,
                                                    currentPage: 1,
                                                }));

                                            }}
                                            isClearable={true}
                                            placeholder="Filter by Payment Method"
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            options={paymentTypeOptions}
                                        />
                                    </Col>
                                }

                                {((userState.user.role.name !== "Seller") || (userState.user.is_primary_seller)) &&
                                    <Col sm="">
                                        <Select
                                            className="select2-filter"
                                            styles={customStyles}
                                            placeholder="Filter by Return Status"
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            value={orderState.pendingFilters.status}
                                            onChange={(e) => {
                                                dispatch(setPendingReturnFilter({
                                                    ...orderState.pendingFilters,
                                                    status: e ? e : null,
                                                    customStatus: null,
                                                    currentPage: 1,
                                                }));
                                            }}
                                            isClearable={true}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            options={statuses}
                                        />
                                    </Col>
                                }

                                {((userState.user.role.name !== "Seller") || (userState.user.is_primary_seller)) &&
                                    <Col sm="">
                                        <Select
                                            className="select2-filter"
                                            styles={customStyles}
                                            placeholder="Filter by Tracking Status"
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            value={orderState.pendingFilters.trackingStatus}
                                            onChange={(e) => {
                                                dispatch(setPendingReturnFilter({
                                                    ...orderState.pendingFilters,
                                                    trackingStatus: e ? e : null,
                                                    customStatus: null,
                                                    currentPage: 1,
                                                }));
                                            }}
                                            isClearable={true}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            options={trackingStatuses}
                                        />
                                    </Col>
                                }
                            </Row>
                            <Row>

                                {/*{userState.user.role.name !== "Seller" && <Col md={userState.user.role.name !== "Seller" ? '' : 4}>
                                    <AsyncSelect
                                        className="select2-filter"
                                        isClearable={true}
                                        menuPortalTarget={document.body}
                                        value={orderState.pendingFilters.seller}
                                        defaultOptions
                                        placeholder="Filter by Seller"
                                        loadOptions={sellerPromiseOption}
                                        styles={{ ...customStyles, menuPortal: base => ({ ...base, zIndex: 100 }) }}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onClear={(e) => {

                                        }}
                                        onChange={(e) => {
                                            dispatch(setPendingReturnFilter({
                                                ...orderState.pendingFilters,
                                                seller: e ? e : null,
                                                currentPage: 1,
                                            }));
                                        }}

                                    />
                                </Col>}
                                <Col md={userState.user.role.name !== "Seller" ? '' : 4}>
                                    <Select
                                        placeholder="Filter by Seller Brand"
                                        className="select2-filter"
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        isClearable
                                        cacheOptions
                                        styles={customStyles}
                                        options={brands}
                                        defaultValue={orderState.pendingFilters.brand}
                                        onChange={(e) => {
                                            dispatch(setPendingReturnFilter({
                                                ...orderState.pendingFilters,
                                                brand: e ? e : null,
                                                currentPage: 1,
                                            }));
                                        }}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}

                                    />
                                </Col>*/}
                                {/*<Col  md={userState.user.role.name!=="Seller" ? 3 :3}>*/}
                                {/*    <Select*/}
                                {/*        placeholder={<div>Return Reason</div>}*/}
                                {/*        className="select2-filter"*/}
                                {/*        getOptionLabel={(option) => option.name}*/}
                                {/*        getOptionValue={(option) => option.id}*/}
                                {/*        isClearable*/}
                                {/*        cacheOptions*/}
                                {/*        styles={customStyles}*/}
                                {/*        options={orderState.customerReturnReasons}*/}
                                {/*        onChange={(e) => {*/}
                                {/*            setReturnReason(e ? e.id : null)*/}
                                {/*        }}*/}
                                {/*        components={{*/}
                                {/*            IndicatorSeparator: () => null*/}
                                {/*        }}*/}

                                {/*    />*/}
                                {/*</Col>*/}

                                <Col md="">
                                    <FormGroup>
                                        <Select
                                            placeholder="Filter by Return Type"
                                            className="select2-filter"
                                            isClearable
                                            cacheOptions
                                            styles={customStyles}
                                            options={returnTypeOptions}
                                            defaultValue={orderState.pendingFilters.type}
                                            onChange={(e) => {
                                                dispatch(setPendingReturnFilter({
                                                    ...orderState.pendingFilters,
                                                    type: e ? e : null,
                                                    currentPage: 1,
                                                }));
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                        />
                                    </FormGroup>
                                </Col>

                                {/*{userState.user.role.name !== "Seller" && <Col md="">
                                    <Form onSubmit={(e) => {
                                        e.preventDefault();
                                    }}>
                                        <FormGroup className="m-0">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                defaultValue={orderState.pendingFilters.mp_order_no}
                                                onChange={(e) => {
                                                    clearTimeout(timer);
                                                    const newTimer = setTimeout(() => {
                                                        dispatch(setPendingReturnFilter({
                                                            ...orderState.pendingFilters,
                                                            mp_order_no: e.target.value,
                                                            currentPage: 1,
                                                        }));
                                                    }, 500);
                                                    setTimer(newTimer)
                                                }}
                                                placeholder="Search by Mp Order Number"
                                            />
                                            <i className="fa fa-search"></i>
                                        </FormGroup>
                                    </Form>
                                </Col>}*/}

                                <Col md={userState.user.role.name !== "Seller" ? '' : 4}>
                                    <Form onSubmit={(e) => {
                                        e.preventDefault();
                                    }}>
                                        <FormGroup className="m-0">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                defaultValue={orderState.pendingFilters.search}
                                                onChange={(e) => {
                                                    clearTimeout(timer);
                                                    const newTimer = setTimeout(() => {
                                                        dispatch(setPendingReturnFilter({
                                                            ...orderState.pendingFilters,
                                                            search: e.target.value,
                                                            currentPage: 1,
                                                        }));

                                                    }, 500);
                                                    setTimer(newTimer);
                                                }}
                                                placeholder="Search Order"
                                            />
                                            <i className="fa fa-search"></i>
                                        </FormGroup>
                                    </Form>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <Select getOptionLabel={(option) => option.sku}
                                            getOptionValue={(option) => option.id}
                                            value={selectedSkus}
                                            menuPortalTarget={document.body}
                                            isMulti={true}
                                            styles={customStyles}
                                            placeholder="Search by SKUs"
                                            onChange={handleSkuValue} 
                                            onInputChange={handleInputChangeSku}
                                            onMenuScrollToBottom={handleMenuScrollToBottomSKU}
                                            onMenuOpen={handleMenuOpenSKU}
                                            isLoading={loadingSku}
                                            className={` ${skuError ? 'is-invalid' : ''}`}
                                            options={skuOptions}
                                            noOptionsMessage={() => 'No product found'}/>
    
                                    <div className="invalid-feedback">{skuError ? "You can only add up to 10 SKUs" : ""}</div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <StatusSummary orderState={orderState} />

                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody>
                                    <div className="table-responsive product-table">
                                        <CommonDataTable
                                            headerColumns={tableColumns}
                                            gridData={orderState.returnRequestData ? mapReturnRequestResponseToTable(orderState.returnRequestData) : ""}
                                            noAction
                                            progressPending={loading}
                                            paginationServer
                                            paginationTotalRows={orderState.orderTableRow}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            onChangeRowsPerPage={onPageSizeChange}
                                            onChangePage={pageChange}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>}
        </Fragment>
    );
}

export default withReducer([{ order: orderReducer }])(PendingReturn);